module.exports = __webpack_public_path__ + "static/3bcd887f89c069f3db26e01c0c94f0b123a4cdd8d220c34630119f440bcb9667-c7b35dad5475e18cfd7a9985bd17bf1a.png";